import React from "react";

export const getProfileFields = (data = {}) => {
    const { profile } = data;

    return [
        {
            name: `Пол`,
            value: profile?.gender
                ? profile?.gender === "M"
                    ? "Мужской"
                    : "Женский"
                : "",
            icon: `user`,
        },
        {
            name: `Номер телефона`,
            value: profile?.phone ? (
                <a href={`tel:${profile?.phone}`}>{profile?.phone}</a>
            ) : (
                ""
            ),
            icon: `call`,
        },
        {
            name: `Возраст`,
            value: profile?.birthday ? calculateAge(profile.birthday) : "",
            icon: `calendar`,
        },
        {
            name: `Город`,
            value: data?.cityName,
            icon: `location`,
        },
        {
            name: `Рост`,
            value: profile?.height,
            icon: `height`,
            classes: "profile__value--height",
        },
    ];
};

export const calculateAge = (birthDate) => {
    const birthday = new Date(birthDate);
    const today = new Date();

    const yearsDiff = today.getFullYear() - birthday.getFullYear();
    const monthsDiff = today.getMonth() - birthday.getMonth();
    const daysDiff = today.getDate() - birthday.getDate();

    if (monthsDiff < 0 || (monthsDiff === 0 && daysDiff < 0)) {
        return Math.floor(yearsDiff - 1);
    }

    return Math.floor(yearsDiff);
};
